<script lang="ts">
  import { Accordion, AccordionSection, Button, Card } from 'attractions'
  import MdiChevronDown from '~icons/mdi/chevron-down'
  import Api from './api/Api.svelte'
  import Editor from './Editor.svelte'
</script>

<div style="display: flex; flex-direction: column;">
  <h1 style="text-align:center">Robot Programming Environment</h1>

  <Accordion let:closeOtherPanels>
    <AccordionSection on:panel-open={closeOtherPanels}>
      <div slot="handle" let:toggle>
        <Button on:click={toggle}>Read Me First!<MdiChevronDown /></Button>
      </div>
      <Card outline>
        <p>Welcome to the Robot Programming Environment!</p>
        <p>This is where you can write your code and load it into the robot.</p>
        <p>The environment consists of three main sections:</p>
        <ul>
          <li>
            <strong>These Instructions</strong>
            &mdash; providing you with a brief overview of the environment and how to use it.
          </li>
          <li>
            <strong>The Robot Application Programming Interface (API)</strong>
            &mdash; which provides you with the necessary information to write the code to control your robot.
          </li>
          <li>
            And <strong>The Code Editor</strong>
            &mdash; which is where you write your code, compile it, and, if it compiles successfully, load it into your robot.
          </li>
        </ul>
      </Card>
    </AccordionSection>
    <AccordionSection on:panel-open={closeOtherPanels}>
      <div slot="handle" let:toggle>
        <Button on:click={toggle}>Robot API<MdiChevronDown /></Button>
      </div>
      <Card outline>
        <p>
          The Robot API provides you with the necessary information to write the code to control your robot. The API
          consists of a set of functions that you can use to control the robot's movement and actions. The API is
          documented below.
        </p>
        <p>
          We use Java as the programming language for the robot. The API is written in Java, and you will write your
          code in Java as well. The API consists of the following functions:
        </p>
        <Api />
      </Card>
    </AccordionSection>
    <AccordionSection on:panel-open={closeOtherPanels}>
      <div slot="handle" let:toggle>
        <Button on:click={toggle}>Code Editor<MdiChevronDown /></Button>
      </div>
      <Card outline>
        <p>
          The Code Editor is where you write your code, compile it, and, if it compiles successfully, load it into your
          robot. The editor provides you with syntax highlighting, code completion, and error checking to help you write
          your code.
        </p>
        <p>
          To write your code, you can use the Robot API functions documented above. The API provides you with the
          necessary information to control your robot's movement and actions.
        </p>
        <Editor />
      </Card>
    </AccordionSection>
  </Accordion>
</div>
